import { generateBulkPaymentTemplate, downloadFile } from '../../../../../helpers/excel';
import PropTypes from 'prop-types';
import ActionConfirmModal from '../../../../../new-ui/components/common/ActionConfirmModal';

const DownloadExcelModal = ({ open, handleClose, data, name }) => {
    const getTitleAndFilename = name => {
        switch (name) {
            case 'bulkPaymentTemplate':
                return 'Bulk Payment Template';
        }
    };

    const generateExcel = async name => {
        switch (name) {
            case 'bulkPaymentTemplate': {
                let fileName = getTitleAndFilename(name);
                let file = await generateBulkPaymentTemplate();
                return downloadFile(file, fileName);
            }
        }
    };

    return (
        <ActionConfirmModal
            open={open}
            heading="Download Excel"
            onCancel={handleClose}
            onConfirm={async () => {
                handleClose();
                await generateExcel(name, data);
            }}
            subHeading={'Are you sure you want to download Excel file with all the information?'}
            body={() => (
                <>
                    {name === 'bulkPaymentTemplate' && (
                        <p className="text-sm text-text leading-relaxed text-center">
                            <strong>Heads up:</strong> Follow the instructions present in
                            Instructions tab and add your transactions in Transactions tab
                        </p>
                    )}
                </>
            )}
            actionButtonText="download"
        />
    );
};

DownloadExcelModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    data: PropTypes.any,
    name: PropTypes.string.isRequired,
};

export default DownloadExcelModal;
